import { render, staticRenderFns } from "./modal_semester_year.vue?vue&type=template&id=447a417b"
import script from "./modal_semester_year.vue?vue&type=script&lang=js"
export * from "./modal_semester_year.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports